export default __webpack_public_path__ + "static/media/bngus.54a96274.webp";